<template>
  <div>
    <p
        :class="errorContextProps.isError ? 'hidden' : ''"
        class="txt_info txt_gray"
    >
      {{ $t('account.request_email+id_sentence') }}
    </p>
    <p
        :class="errorContextProps.isError ? '' : 'hidden'"
        class="txt_info txt_red"
    >
      {{ errorContextProps.context }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'FindPwErrorContext',
  props: {
    errorContextProps: {
      isError: Boolean,
      context: String
    }
  }
}
</script>